import React from "react";
import {Box} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

export const ValidationInputCheckMark = React.forwardRef<any, any>(() => {
  return (
    <Box style={{position: "relative"}}>
      <CheckIcon
        fontSize="large"
        // We have to position the icon absolutely because the input field uses `fullWidth`.
        style={{ position: "absolute", top: "-60px", right: "-40px" }}
        color="primary"
      />
    </Box>
  );
});

